export default function mapAnswersToPayload({
  answers,
  questions,
  applicantId,
  questionnaireId,
  sectionId,
}: {
  answers: Record<number, any>;
  questions: any[];
  applicantId: number;
  questionnaireId: number;
  sectionId: number;
}) {
  return questions
    .filter((q) => answers[q.id] !== undefined)
    .map((q) => {
      const value = answers[q.id];

      return {
        applicant_id: applicantId,
        questionnaire_id: questionnaireId,
        section_id: sectionId,
        question_id: q.id,
        question_no: q.question_no,
        selected_option_ids: Array.isArray(value) ? value : null,
        text_answer: typeof value === "string" ? value : null,
        rating: typeof value === "number" ? value : null,
        captured: true,
      };
    });
}

export function buildSafeAnswer(raw: any) {
  const payload: any = {
    question_id: raw.question_id,
    section_id: raw.section_id,
    applicant_id: raw.applicant_id,
    questionnaire_id: raw.questionnaire_id,
    question_no: raw.question_no,
  };

  if (typeof raw.text_answer === "string") {
    payload.text_answer = raw.text_answer;
  }

  if (typeof raw.rating === "number") {
    payload.rating = raw.rating;
  }

  if (typeof raw.not_applicable_flag === "boolean") {
    payload.not_applicable_flag = raw.not_applicable_flag;
  }

  if (Array.isArray(raw.selected_option_ids)) {
    payload.selected_option_ids = raw.selected_option_ids.join("\n");
  } else if (typeof raw.selected_option_ids === "string") {
    payload.selected_option_ids = raw.selected_option_ids;
  }

  if (typeof raw.other_text === "string") {
    payload.other_text = raw.other_text;
  }

  return payload;
}
